/**
 * Inline responses for the bulk invoice challenge composer on Open Invoice
 * Audits. Grouped out of inlineResponses.tsx to keep that file under the
 * 400-line limit, following the sibling-group convention documented there.
 */
export const INVOICE_CHALLENGE_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Starting template for the selected challenge type. Mirrors the backend's
  // Apply Quote per-audit template (backend/snapshots/challengeInvoiceTemplates).
  "/apollo/support-email/carrier-invoice-challenge-template": {
    subject: "Apply Quoted Price{{#if pro}} – PRO # {{pro}}{{/if}}",
    bodyMarkdown:
      "**Re: Account {{accountNumber}}**\n\n{{#if pro}}For Pro {{pro}}, the invoice does not match the quoted price.{{else}}The invoice does not match the quoted price.{{/if}}\n\nQuote ID #{{quoteReference}} is for ${{quotedPrice}} {{quoteCurrency}}. Price on the invoice is ${{invoiceAmount}} {{invoiceCurrency}}.\n\nPlease fix to the quoted price & issue an updated invoice.",
    mergeFields: [
      { key: "pro", description: "PRO number on the carrier invoice" },
      { key: "shipmentPro", description: "PRO number on the shipment" },
      { key: "invoiceAmount", description: "Amount on the carrier invoice" },
      {
        key: "invoiceCurrency",
        description: "Currency of the carrier invoice",
      },
      { key: "quotedPrice", description: "Price the carrier quoted" },
      { key: "quoteCurrency", description: "Currency of the quoted price" },
      { key: "quoteReference", description: "Carrier's quote ID" },
      {
        key: "accountNumber",
        description: "Our account number with the carrier",
      },
      {
        key: "challengeDetails",
        description:
          "Evidence for this challenge type (line items, rate explanation, API calls)",
      },
    ],
    introMergeFields: [],
  },
  // Preview of one audit's email, as the composer shows it beside the editor.
  "/apollo/support-email/preview-bulk-carrier-invoice-challenge-email": {
    addresses: ["billing@apex.example"],
    subject: "Apply Quoted Price – PRO # 3045512",
    emailBody:
      '<div style="font-family: Calibri, sans-serif; font-size: 14px;"><p><strong>Re: Account 802113</strong></p><p>For Pro 3045512, the invoice does not match the quoted price.</p><p>Quote ID #Q-77812 is for $412.50 CAD. Price on the invoice is $566.10 CAD.</p><p>Please fix to the quoted price &amp; issue an updated invoice.</p></div>',
  },
  "/apollo/support-email/send-bulk-carrier-invoice-challenge-email": [],
};
